import {AddLevelToPlaylistSchema} from "@repo/shared";

import {functionHookFactory} from "../factories/functionHookFactory";

export const useAddLevelToPlaylist = functionHookFactory(
  "addLevelToPlaylist",
  AddLevelToPlaylistSchema,
);
